import { useState } from 'react';
import { Button } from 'shared-components';
import { UploadZone } from '../uploader/upload-zone';
import { close } from '../modal/modalSlice';
import { ButtonTier } from 'shared-components';
import { useAppDispatch } from '../../app/hooks';
import { Upload } from '../uploader/uploader.types';
import { useSetLogoMutation, useSetLogoLightMutation } from './settings.api';
import styles from './logo-upload-modal.module.css';

export const LogoUploadModal = ({
  variant = 'default',
}: {
  variant?: 'default' | 'light';
}) => {
  const dispatch = useAppDispatch();
  const [uploadList, setUploadList] = useState<
    Pick<Upload, 'file' | 'destination'>[]
  >([]);
  const [setLogo] = useSetLogoMutation();
  const [setLogoLight] = useSetLogoLightMutation();
  const upload = variant === 'light' ? setLogoLight : setLogo;
  return (
    <div className={styles.logoUploadModal}>
      <UploadZone
        className={styles.uploadZone}
        allowMultiple={false}
        onlyOneMessage="Please select only one file"
        onFileChange={(files) => {
          const newList = files.map((file) => ({
            file,
            destination: ``,
          }));
          setUploadList(newList);
        }}
      />
      <Button
        bigger={true}
        tier={ButtonTier.Secondary}
        onClick={() => {
          dispatch(close());
        }}
      >
        Cancel
      </Button>
      {uploadList.length > 0 && (
        <Button
          bigger={true}
          onClick={async () => {
            await upload({
              image: uploadList[0].file,
            });

            dispatch(close());
          }}
        >
          Upload
        </Button>
      )}
    </div>
  );
};
